<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-base px-6 py-12">
    <a href="/" class="flex items-center gap-2.5 mb-8">
      <img src="@/assets/logo-2.png" alt="Akademi Siber" class="h-10" />
      <span class="text-lg font-extrabold text-white">Akademi<span class="text-brand">Siber</span></span>
    </a>

    <div class="card w-full max-w-md p-8">
      <h1 class="text-2xl font-extrabold text-white mb-1">Reset Password</h1>
      <p class="text-ink-muted text-sm mb-6">Enter your new password below to reset it.</p>

      <form @submit.prevent="updatePassword" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-ink-muted mb-1.5" for="newPassword">New Password</label>
          <input v-model="newPassword" class="input" id="newPassword" placeholder="••••••••" type="password" />
        </div>
        <div>
          <label class="block text-sm font-medium text-ink-muted mb-1.5" for="confirmPassword">Confirm Password</label>
          <input v-model="confirmPassword" class="input" id="confirmPassword" placeholder="••••••••" type="password" />
        </div>
        <button class="btn-primary w-full justify-center py-3" :disabled="isLoading || !newPassword || !confirmPassword" type="submit">
          {{ isLoading ? "Updating..." : "Reset Password" }}
        </button>
      </form>

      <p v-if="message" :class="['text-center text-sm mt-4', isError ? 'text-brand' : 'text-success']">
        {{ message }}
      </p>

      <p class="text-center text-sm text-ink-muted mt-6">
        Remember your password?
        <a class="font-semibold text-brand hover:text-brand-light" href="/login">Sign In</a>
      </p>
    </div>

    <p class="text-ink-faint text-xs mt-8">© 2025 SiberLab ID</p>
  </div>
</template>

<script>
import toastr from "toastr"; // Importing Toastr
import "toastr/build/toastr.min.css"; // Importing Toastr CSS
import apiClient from "@/axiosConfig"; // Importing Axios configuration

toastr.options = {
  positionClass: "toast-bottom-right",
  closeButton: true,
  progressBar: true,
  timeOut: 5000,
};

export default {
  name: "ResetPassword",
  data() {
    return {
      newPassword: "",
      confirmPassword: "",
      isLoading: false,
      message: "",
      isError: false,
    };
  },
  methods: {
    async updatePassword() {
      this.isLoading = true;
      this.message = "";
      this.isError = false;

      // Validate passwords match
      if (this.newPassword !== this.confirmPassword) {
        this.isLoading = false;
        this.isError = true;
        this.message = "Passwords do not match!";
        toastr.error(this.message, "Error");
        return;
      }

      try {
        const token = this.$route.params.token; // Get token from the route params

        // Make POST request to update password
        await apiClient.post("/auth/update-password", {
          token,
          newPassword: this.newPassword,
        });

        // Show success message
        this.message = "Password updated successfully!";
        toastr.success(this.message, "Success");

        // Clear password fields
        this.newPassword = "";
        this.confirmPassword = "";

        // Redirect to login
        this.$router.push("/login");
      } catch (error) {
        // Handle errors
        this.isError = true;
        this.message =
          error.response?.data?.message || "Failed to reset password. Please try again.";
        toastr.error(this.message, "Error");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
